import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { tryToBuildImgixUrl } from '../../../utils/imgix';
import { Store } from '../../../store';
import { useMemoizedFrame } from '../../../utils/hooks';

export const OGImage: React.FC<{ id: string; isExpert: boolean; scrollToBottomIfClose: () => void }> = (
  props
) => {
  const { id, isExpert, scrollToBottomIfClose } = props;
  const ogImageInfo = Store.useState((s) => s.ogLinkInfo[id], [id]);
  const { window } = useMemoizedFrame();
  if (!ogImageInfo) return null;
  const { image, title, link, price, currency, video } = ogImageInfo;
  const compressedImage = tryToBuildImgixUrl(image, { w: 370, h: 190, auto: 'format,compress' });
  return (
    <Box onClick={() => window?.open(link, '_blank')} cursor="pointer" mt="12px">
      <Box h="100%" w="100%" background="scheme.backgroundSecondary" borderRadius="4px" maxH="264px">
        {video ? (
          <iframe
            src={video}
            height="264px"
            width="100%"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            title={title}
            allowFullScreen
          />
        ) : (
          <Image
            src={compressedImage}
            aria-hidden={true}
            borderRadius="4px"
            maxHeight="264px"
            mixBlendMode="darken"
            m="auto"
            sx={{
              WebkitUserSelect: 'none',
              WebkitUserDrag: 'none'
            }}
            onLoad={scrollToBottomIfClose}
          />
        )}
      </Box>
      <Text
        variant="label-large"
        mt="4px"
        color={isExpert ? 'scheme.contentPrimary' : 'scheme.contentInversePrimary'}
      >
        {title}
      </Text>
      {price && currency && (
        <Text
          color={isExpert ? 'scheme.contentPrimary' : 'scheme.contentInversePrimary'}
          variant="label-small"
          mt="4px"
        >
          {Intl.NumberFormat(window?.navigator.language, {
            style: 'currency',
            currency: currency
          }).format(price)}
        </Text>
      )}
    </Box>
  );
};
